<template>
  <div class="mc-page">

    <!-- Hero -->
    <div class="mc-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-format-list-text</v-icon>
        </v-avatar>
        <div>
          <div class="mc-hero__title">Motivos de descuentos</div>
          <div class="mc-hero__sub">Administración de motivos por tipo de descuento</div>
        </div>
      </div>
      <v-chip small color="rgba(255,255,255,0.15)" dark>
        <v-icon left small>mdi-school-outline</v-icon> Académico
      </v-chip>
    </div>

    <div class="mc-body">

      <!-- Filtros + acción -->
      <v-card outlined class="mc-filters-card mb-4">
        <v-card-title class="mc-filters-card__title py-2 px-4">
          <v-icon small color="indigo darken-2" class="mr-1">mdi-filter-outline</v-icon>
          Filtros
        </v-card-title>
        <v-card-text class="pt-3 pb-3 px-4">
          <v-row dense align="center">
            <v-col cols="12" sm="3">
              <v-combobox v-model="descuentostipo" :loading="loadingd" :items="descuentostipos"
                :value="'nombre'" label="Tipo descuento" hide-details outlined dense
                prepend-inner-icon="mdi-tag-outline" />
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field v-model="buscar" label="Buscar"
                :disabled="motivos.length == 0"
                placeholder="Buscar en la tabla..." hide-details outlined dense
                prepend-inner-icon="mdi-magnify" clearable />
            </v-col>
            <v-col cols="12" sm="3" offset-sm="3" class="d-flex justify-end">
              <v-btn color="indigo darken-1" dark depressed @click="crearmotivo()">
                <v-icon left small>mdi-plus</v-icon> Crear motivo
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Tabla -->
      <v-card outlined class="mc-table-card">

        <div class="mc-table-toolbar px-4 py-2 d-flex align-center" style="gap:8px;">
          <v-chip x-small :color="motivos.length ? 'indigo lighten-5' : 'grey lighten-3'"
            class="indigo--text text--darken-2 font-weight-medium">
            {{ motivos.length }} registro{{ motivos.length !== 1 ? 's' : '' }}
          </v-chip>
          <v-spacer />
          <v-progress-circular v-if="loading" indeterminate color="indigo" size="20" width="2" />
        </div>

        <v-divider />

        <v-data-table
          :headers="headers"
          :items="motivos"
          :loading="loading"
          :search="buscar"
          dense
          loading-text="Cargando motivos..."
          no-data-text="Sin motivos. Seleccione un tipo de descuento."
          class="mc-table"
        >
          <!-- Nro -->
          <template v-slot:[`item.nro`]="{ index }">
            {{ index + 1 }}
          </template>

          <!-- Fecha -->
          <template v-slot:[`item.fecha_registro`]="{ item }">
            {{ parsefecha(item.fecha_registro) }}
          </template>
        </v-data-table>

        <p v-if="msg" class="text-center red--text ma-2" style="font-size:0.85rem;">
          <b>{{ msg }}</b>
        </p>
      </v-card>

    </div>

    <MotivoCreate ref="motivocreate" />
  </div>
</template>

<script>
import MotivoCreate from "@/components/AMotivo-create.vue";
import axios from "axios";

export default {
  data() {
    return {
      descuentostipos: [],
      descuentostipo: { value: '', text: '' },
      loadingd: false,
      loading: false,
      unidad_negocio: -1,
      msg: "",
      motivos: [],
      buscar: "",
      headers: [
        { text: 'Nro',            value: 'nro',               width: '70',  sortable: false },
        { text: 'Descripción',    value: 'descripcion' },
        { text: 'Fecha registro', value: 'fecha_registro',    width: '150' },
        { text: 'Tipo',           value: 'descuento_tipo',    width: '160' },
        { text: 'ID Negocio',     value: 'unidad_negocio_id', width: '110' },
      ],
    };
  },
  components: { MotivoCreate },
  watch: {
    "$store.state.CARGO": function() {
      try {
        this.unidad_negocio = this.$store.state.CARGO.sede.unidad_negocio;
        this.listarmotivos();
      } catch (e) {
        window.console.error(e);
      }
    },
    'descuentostipo.value': function() {
      this.listarmotivos();
    },
  },
  methods: {
    crearmotivo() {
      this.$refs.motivocreate.open();
    },
    parsefecha(f) {
      if (!f) return "-";
      let fs = f.split(" ");
      let fs1 = fs[0].split("-");
      let fs2 = fs[1].split(":");
      return `${fs1[2]}/${fs1[1]}/${fs1[0]} ${fs2[0]}:${fs2[1]}`;
    },
    listarmotivos() {
      const vue = this;
      let url = `${process.env.VUE_APP_API_REST}/api/v1/motivos?unidad_negocio_id=${this.unidad_negocio}`;
      if (this.descuentostipo.id > 0) url += `&descuento_tipo_id=${this.descuentostipo.id}`;
      window.console.log(url);
      this.motivos = [];
      vue.loading = true;
      axios
        .get(url)
        .then((res) => {
          window.console.log(res);
          if (res.data == "") res.data = { data: [] };
          vue.motivos = res.data.data;
          vue.loading = false;
        })
        .catch((error) => {
          window.console.error(error);
          vue.loading = false;
        });
    },
    getdescuentostipos() {
      const vue = this;
      const url = `${process.env.VUE_APP_API_REST}/api/v1/descuento-tipos`;
      this.loadingd = true;
      axios.get(url).then((res) => {
        res.data.data.forEach((x) => {
          x.text = x.nombre;
          x.value = x.id;
          vue.descuentostipos.push(x);
        });
        let todos = { text: 'Todos', id: -1 };
        vue.descuentostipos.push(todos);
        vue.descuentostipo = todos;
        vue.loadingd = false;
      })
      .catch((error) => {
        window.console.log(error);
        vue.loadingd = false;
      });
    },
  },
  mounted() {
    try {
      this.unidad_negocio = this.$store.state.CARGO.sede.unidad_negocio;
      this.listarmotivos();
      this.getdescuentostipos();
    } catch (e) {
      window.console.error(e);
    }
  },
};
</script>

<style scoped>
.mc-page { min-height: 100vh; background: #f5f7fa; }

.mc-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.mc-hero__title { font-size: 1.15rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.mc-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }

.mc-body { padding: 20px 24px; }

.mc-filters-card { border-radius: 10px !important; border-color: #e3e8f0 !important; }
.mc-filters-card__title {
  font-size: 0.8rem !important; font-weight: 700 !important;
  color: #283593; letter-spacing: 0.02em; border-bottom: 1px solid #e8edf7;
}

.mc-table-card { border-radius: 10px !important; border-color: #e3e8f0 !important; overflow: hidden; }

.mc-table-toolbar { background: #fafbff; border-bottom: 1px solid #e8edf7; }

.mc-table >>> thead tr th {
  background: #e8edf7 !important;
  color: #1a237e !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #c5cae9 !important;
  padding: 6px 12px !important;
}
.mc-table >>> tbody tr:hover { background: #f0f4ff !important; }
.mc-table >>> tbody tr td {
  font-size: 0.82rem;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 4px 12px !important;
}
</style>
